<template>
  <div class="my_container">
    <div class="content-list">
    <div class="label-value">
      <div>{{ $t('account.name5') }}</div>
      <div>{{ userinfo.loginName.indexOf('CN-86') > -1 ? userinfo.loginName.slice(6, 17) : userinfo.loginName }}</div>
    </div>
    <!-- <div class="label-value">
      <div>账号归属</div>
      <div>11111</div>
    </div> -->
    <div class="label-value" @click="showTimeZoneDialog">
      <div>{{ $t('account.name3') }}</div>
      <div>{{ timeZoneLabel }}</div>
    </div>
      <div class="label-value" @click="showDrawer">
      <div>{{ $t('account.name6') }}</div>
      <div>{{ language }}</div>
    </div>
    </div>
  <div class="bottom-bt">
      <el-button v-if="userinfo.loginAccountType === 'phone'" type="primary" @click="changeEmail" style="width: 100%;">{{ $t('screen.name46') }}</el-button>
      <el-button v-else type="primary" @click="changeEmail" style="width: 100%;">{{ $t('account.name1') }}</el-button>
      <div class="login-out" @click="logout">{{ $t('public.name7') }}</div>
    </div>
    <el-dialog
  :title="$t('account.name47')"
  :visible.sync="dialogVisible"
  v-if="dialogVisible"
  width="90%"
  :before-close="handleClose">
  <el-select v-model="timeZoneId" filterable style="width: 100%;">
    <el-option
      v-for="item in timeZoneOptions"
      :key="item.id"
      :label="item.label"
      :value="item.id"
    />
  </el-select>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">{{ $t('public.name14') }}</el-button>
    <el-button type="primary" @click="submitTimeZone" :loading="loading">{{ $t('public.name25') }}</el-button>
  </span>
</el-dialog>
<el-drawer
  :visible.sync="drawer"
   direction="btt"
  :with-header="false">
  <div class="drawer-title">
    <div class="titles">{{ $t('account.name6') }}</div>
    <div class="quxiao" @click="drawer=false">{{ $t('account.name9') }}</div>
  </div>
  <div class="drawer-content">
 <div :class="language === $t('account.name10') ? 'item-languages':'item-language'"  @click="changeLanguage('zh')">{{ $t('account.name10') }}</div>
  <div :class="language === 'English' ? 'item-languages':'item-language'"  @click="changeLanguage('en')">{{ $t('account.name11') }}</div>
  </div>
</el-drawer>
  </div>
</template>
<script>
import { updateTimeZone } from '@/api/h5.js'
import { TIME_ZONE_OPTIONS, findTimeZoneLabel, normalizeTimeZoneId, ensureTimeZoneOption } from '@/constants/timeZones'
import { defaultTimeZoneId } from '@/config/flavor'
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      dialogVisible: false,
      timeZoneId: defaultTimeZoneId,
      timeZoneOptions: TIME_ZONE_OPTIONS,
      loading: false,
      language: this.$t('account.name10'),
      drawer: false
    }
  },
  computed: {
    ...mapGetters(['userinfo']),
    timeZoneLabel () {
      const tz = this.userinfo.timeZoneId || this.userinfo.timeZone
      return findTimeZoneLabel(tz)
    }
  },
  created() {
    if (localStorage.getItem('lang') === 'en') {
      this.language = 'English'
    } else {
      this.language = this.$t('account.name10')
    }
  },
  mounted() {
  },
  methods: {
    showDrawer() {
      this.drawer = true
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
      this.$bus.$emit('lang', lang)
      if (lang === 'zh') {
        this.language = this.$t('account.name10')
      } else {
        this.language = 'English'
      }
      this.$emit('update-value')
      this.drawer = false
    },
    logout() {
      this.$store
        .dispatch('user/logout')
        .then(() => {
          Cookies.remove('vue_admin_token')
          localStorage.setItem('buttonPerms', '')
          localStorage.setItem('permName', '')
          localStorage.setItem('menuPerms', '')
          localStorage.setItem('clickIndex', 0)
          this.$router.replace('/login')
        })
        .catch(() => {})
    },
    changeEmail() {
      this.$router.push('/changeEmail')
    },
    showTimeZoneDialog() {
      const tz = this.userinfo.timeZoneId || this.userinfo.timeZone
      this.timeZoneId = normalizeTimeZoneId(tz)
      this.timeZoneOptions = ensureTimeZoneOption(TIME_ZONE_OPTIONS, this.timeZoneId)
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    submitTimeZone() {
      if (this.timeZoneId) {
        this.loading = true
        updateTimeZone({ timeZoneId: this.timeZoneId })
          .then((res) => {
            if (res.code === 200) {
              this.dialogVisible = false
              this.$store.commit('user/updateAlltime', this.timeZoneId)
              this.$bus.$emit('accountTimeZoneChanged', this.timeZoneId)
              this.userinfo.timeZoneId = this.timeZoneId
            }
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.my_container {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  .drawer-title{
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 20px;
    .titles{
      font-weight: 500;
      font-size: 16px;
      color: #555555;
    }
    .quxiao{
      font-size: 15px;
      color: #555555;
    }
  }
  .drawer-content{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 25px;
    .item-languages{
      height: 60px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f5f5;
      font-size: 15px;
      color: #555555;
    }
    .item-language{
      height: 60px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #555555;
    }
  }
  .bottom-bt{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    position: absolute;
    bottom: 36px;
    left: 0;
    padding: 15px;
    .login-out{
      font-size: 16px;
      color: #555;
      margin-top: 15px;
    }
  }
  .content-list{
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    .label-value{
      padding: 15px;
      width: 100%;
      display: flex;
      background: #fff;
      align-items: center;
      border-bottom: 1px solid #dddee1;
      justify-content: space-between;
    }
  }
}

@media (max-width: 750px) {
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
}
</style>
